/**
 * shadcn/ui's class joiner: clsx for conditionals, tailwind-merge so a later utility
 * overrides an earlier one of the same property.
 *
 * Author: Mahmoud Ragab Ahmed.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
